import { render, staticRenderFns } from "./duzeltRehber.vue?vue&type=template&id=17f3f0cc"
import script from "./duzeltRehber.vue?vue&type=script&lang=js"
export * from "./duzeltRehber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports